import { render, staticRenderFns } from "./pfooter.vue?vue&type=template&id=4b17d85e&scoped=true&"
import script from "./pfooter.vue?vue&type=script&lang=js&"
export * from "./pfooter.vue?vue&type=script&lang=js&"
import style0 from "./pfooter.vue?vue&type=style&index=0&id=4b17d85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17d85e",
  null
  
)

export default component.exports